import router from './routerMap.js'
import store from '../store'
import Crypto from '../libs/common/crypto' // 加密解密文件
import cryptoPhp from '../libs/common/cryptoPhp'// 加密解密文件

router.beforeEach((to, from, next) => {
  store.commit('ADD_PATH', from.path)
  store.commit('ADD_META', to.meta)
  document.title = to.meta.title
  // 判断是否进入个人中心验证是否绑定手机号   JSON.parse(window.localStorage.id_user).mobile
  if (to.path === '/' || to.path === '/index' || to.path === '/check' || to.path === '/login' || to.path === '/Login' || to.path === '/form/retrievePassword') {
    if (window.localStorage.bindMobileUrl !== 'index') {
      window.localStorage.bindMobile = 1
    }
  } else {
    if (!window.localStorage.id_user) {
      window.localStorage.bindMobile = 0
    } else {
      if (!JSON.parse(window.localStorage.id_user).mobile) {
        window.localStorage.bindMobile = 0
      } else {
        if (window.localStorage.bindMobileUrl !== 'index') {
          window.localStorage.bindMobile = 1
        }
      }
    }
  }
  if (to.query.ssologout || to.query.loginfirst) {
    window.localStorage.removeItem('id_user')
    store.state.Auth.jrwyToken = ''
  }
  if (to.meta.intercept && !store.state.Auth.jrwyToken) {
    next('/Login?userType=' + to.query.userType)
  }

  if (to.query.userType && to.meta.getType) {
    store.commit('ADD_ROLE', to.query.userType)
  }
  if (to.query.backurl && to.meta.getType) {
    store.commit('ADD_BACKURL', to.query.backurl)
  }
  if (to.path !== '/signUp' && to.query.jrwyToken) {
    if (to.query.source) {
      next({
        path: '/signUp',
        query: {
          userType: to.query.userType,
          jrwyToken: to.query.jrwyToken,
          source: to.query.source
        }
      })
    } else {
      next({
        path: '/signUp',
        query: {
          userType: to.query.userType,
          jrwyToken: to.query.jrwyToken
        }
      })
    }
  }

  if (!store.state.Auth.jrwyToken && !to.meta.intercept && to.meta.auth && to.path !== '/form/retrievePassword' && !to.query.jrwyToken) {
    next('/Login')
  } else if (store.state.Auth.jrwyToken) {
    let userType = store.state.Role.role
    let backurl = store.state.Backurl.backurl
    if (to.path === '/check') {
      let backurl = store.state.Backurl.backurl
      let userType = store.state.Role.role
      let identityList = store.state.Auth.identityList
      if (userType) {
        identityList.map(item => {
          if (userType === '2') {
            let source = store.state.Source.source
            // let source = to.query.source ? to.query.source : ''
            if (item.userType.toString() === userType) {
              if (item.auditStatus !== 2) {
                next('/worker/workerInfo?userType=2&source=' + source)
              } else {
                // next('/')
                let jrwyToken = cryptoPhp.Encrypt(JSON.parse(window.localStorage.id_user).jrwyToken)
                let backUrl = `${process.env.VUE_APP_AUTH_URL}/optIdentity?jrwyToken=${encodeURIComponent(jrwyToken)}`
                window.location.href = encodeURI(backUrl)
              }
            } else {
              next('/worker/workerInfo?userType=2&source=' + source)
            }
          } else if (userType === '5') {
            if (window.location.href.indexOf('?backurl=') > 0) {
              let jrwyToken = Crypto.jiami(JSON.parse(window.localStorage.id_user).jrwyToken)
              let backUrl = Crypto.jiemi(backurl) + '?jrwyToken=' + jrwyToken
              store.commit('ADD_CLEARURL')
              window.location.href = backUrl
            } else {
              next('/worker/workerInfo?userType=5')
            }
          } else if (userType === '4') {
            if (window.location.href.indexOf('?backurl=') > 0) {
              let jrwyToken = Crypto.jiami(JSON.parse(window.localStorage.id_user).jrwyToken)
              let backUrl = Crypto.jiemi(backurl) + '?jrwyToken=' + jrwyToken
              store.commit('ADD_CLEARURL')
              window.location.href = backUrl
            } else {
              next('/worker/workerInfo?userType=4')
            }
          } else if (userType === 'guangwang') {
            let jrwyToken = cryptoPhp.Encrypt(JSON.parse(window.localStorage.id_user).jrwyToken)
            let backUrl = cryptoPhp.Decrypt(backurl) + '?jrwyToken=' + encodeURIComponent(jrwyToken);
            store.commit('ADD_CLEARURL')
            window.location.href = encodeURI(backUrl)
          }
        })
      } else {
        next('/')
      }
    } else if (to.meta.keepLogin) {
      if ((userType === 'guangwang' || userType === '4' || userType === '5') && !to.query.ssologout) {
        if (window.localStorage.id_user) {
          let jrwyToken = cryptoPhp.Encrypt(JSON.parse(window.localStorage.id_user).jrwyToken)
          let backUrl = cryptoPhp.Decrypt(backurl) + '?jrwyToken=' + encodeURIComponent(jrwyToken);
          store.commit('ADD_CLEARURL')
          window.location.href = encodeURI(backUrl)
        }
      } else if (to.query.ssologout) {
        window.localStorage.clear()
        next('/Login')
      } else {
        next('/')
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
